import imageCompression from "browser-image-compression";

export const compressImage = async (file) => {
    const options = {
        maxSizeMB: 0.2,            // Target size (200 KB)
        maxWidthOrHeight: 800,     // Resize
        useWebWorker: true,
    };

    try {
        const compressedFile = await imageCompression(file, options);

        console.log("Original:", file.size / 1024, "KB");
        console.log("Compressed:", compressedFile.size / 1024, "KB");

        return compressedFile;
    } catch (error) {
        console.error("Image compression error:", error);
        return file; // fallback to original
    }
};
